import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

const THead = props => {
  const { children, className } = props;

  return (
    // <div
    //   className={cn(
    //     "responsive-table__tbody",
    //     className
    //   )}
    // >
    //   {children}
    // </div>
    <thead className={cn(className, 'responsive-table__thead')}>{children}</thead>
  );
};

THead.propsType = {
  children: PropTypes.node,
  className: PropTypes.string
};

export default THead;



// WEBPACK FOOTER //
// ./src/containers/responsive-table/thead.js